module.exports = __webpack_public_path__ + "img/figure03.d15acf3c.png";